<h2>{{ 'INPUT.SELECT_WITH_TREE.TITLE' | translate }}</h2>

This is a form component that allows the user to select an option from a list of options <strong>from a tree</strong>. The component can be
configured:
<ul>
  <li>to display a search bar filtering the options</li>
  <li>to allow selecting multiple options (multiple mode)</li>
  <ul>
    <li>to manage selected options in a "cart" (in multiple mode)</li>
  </ul>
</ul>

<div class="gap-2">
  <p>Toggle the options and see the result below:</p>
  <vitamui-slide-toggle class="col" [(ngModel)]="enableSearch">Display search bar</vitamui-slide-toggle>
  <vitamui-slide-toggle class="col" [(ngModel)]="enableDisplaySelected">Display "cart" (in multiple mode) </vitamui-slide-toggle>
</div>

@if (schemaOptions$ | async; as schemaOptions) {
  @for (config of configs; track config.name) {
    <h3>{{ config.name }}</h3>
    @for (entry of config.entries; track entry.type) {
      <div class="container-fluid p-0">
        <div class="row">
          @for (state of entry.states; track state.id) {
            <div class="col">
              <h4>{{ state.id + ' (' + entry.type + ')' }}</h4>
              <vitamui-select-with-tree
                [attr.data-active]="state.id === 'Active'"
                [formControl]="state.control"
                [options]="schemaOptions"
                [placeholder]="'INPUT.SELECT_WITH_TREE.PLACEHOLDER' | translate"
                [searchBarPlaceHolder]="'INPUT.SELECT_WITH_TREE.SEARCH_BAR_PLACEHOLDER' | translate"
                [multiple]="config.multiple"
                [enableSearch]="enableSearch"
                [enableDisplaySelected]="enableDisplaySelected"
                [getDisplayValue]="getSchemaElementDisplayValue"
                [errorMessageMap]="{
                  pattern: 'ERRORS.CONTAINS_TextContent',
                }"
              >
              </vitamui-select-with-tree>
            </div>
          }
        </div>
      </div>
    }
  }
}
